import { Grid, IconButton, Paper, Typography } from '@mui/material'
import Table from '../../components/Table'
import { styled } from '@mui/material/styles'
import { metodoPrograma } from '../../components/api'
import { isEqual } from 'lodash'
import { memo, useCallback, useContext, useEffect, useState } from 'react'
import { GiReceiveMoney, GiPayMoney, GiTakeMyMoney } from 'react-icons/gi'
import dayjs from 'dayjs'
import { GlobalContext } from '../../App'
import { MdDelete } from 'react-icons/md'

const Visualiza = ({ dados, setDadosEdicao, setTela }) => {
  const { localAtendimento } = useContext(GlobalContext)
  const [lista, setLista] = useState([])
  const [entradas, setEntradas] = useState(0.0)
  const [saidas, setSaidas] = useState(0.0)
  const [resultado, setResultado] = useState(0.0)

  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    height: 100,
    marginTop: 8,
    color: theme.palette.text.secondary,
  }))

  const getList = useCallback(() => {
    metodoPrograma('listaLancamentosCaixa', {
      idCaixa: dados[0],
      idLocalAtendimento: localAtendimento[0],
    }).then((res) => {
      if (res.status) {
        if (res.valorEntrada) {
          setEntradas(res.valorEntrada)
        }
        if (res.valorSaida) {
          setSaidas(res.valorSaida)
        }
        if (res.totalGeral) {
          setResultado(res.totalGeral)
        }
        setLista(res.lista || [])
      }
    })
  }, [dados, localAtendimento])

  const handleClickInLine = (_, item) => {
    setDadosEdicao(item)
    setTela('edicao')
  }

  const excluiLancamentoCaixa = async (e, idLancamento) => {
    e.stopPropagation()
    e.preventDefault()
    const res = await metodoPrograma('excluiLancamentoCaixa', {
      idLancamento,
      idCaixa: dados[0],
    })
    if (res.status) {
      getList()
    }
  }
  useEffect(() => {
    if (dados[0]) {
      getList()
    }
  }, [dados, getList])
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={4} md={4}>
            <Item
              style={{
                backgroundColor: 'rgb(67 160 71 / 61%)',
                padding: 20,
              }}
            >
              <Grid container spacing={2}>
                <Grid xs={6}>
                  <Typography
                    style={{
                      fontSize: 12,
                      fontWeight: 600,
                      textAlign: 'center',
                      padding: 12,
                    }}
                  >
                    <GiReceiveMoney
                      style={{
                        fontSize: 50,
                        color: 'white',
                      }}
                    />
                  </Typography>
                </Grid>
                <Grid
                  xs={6}
                  style={{
                    textAlign: 'right',
                    padding: 12,
                    color: 'white',
                  }}
                >
                  Entradas
                  <br />
                  <Typography
                    style={{
                      fontWeight: 600,
                      textAlign: 'right',
                      fontSize: '1.5em',
                    }}
                  >
                    {entradas.toLocaleString('pt-BR', {
                      style: 'currency',
                      currency: 'BRL',
                    })}
                  </Typography>
                </Grid>
              </Grid>
            </Item>
          </Grid>
          <Grid item xs={12} sm={4} md={4}>
            <Item
              style={{
                backgroundColor: 'rgb(67 160 71 / 61%)',
                padding: 20,
              }}
            >
              <Grid container spacing={2}>
                <Grid xs={6}>
                  <Typography
                    style={{
                      fontSize: 12,
                      fontWeight: 600,
                      textAlign: 'center',
                      padding: 12,
                    }}
                  >
                    <GiPayMoney
                      style={{
                        fontSize: 50,
                        color: 'white',
                      }}
                    />
                  </Typography>
                </Grid>
                <Grid
                  xs={6}
                  style={{
                    textAlign: 'right',
                    padding: 12,
                    color: 'white',
                  }}
                >
                  Saídas
                  <br />
                  <Typography
                    style={{
                      fontWeight: 600,
                      textAlign: 'right',
                      fontSize: '1.5em',
                    }}
                  >
                    {saidas.toLocaleString('pt-BR', {
                      style: 'currency',
                      currency: 'BRL',
                    })}
                  </Typography>
                </Grid>
              </Grid>
            </Item>
          </Grid>
          <Grid item xs={12} sm={4} md={4}>
            <Item
              style={{
                backgroundColor: 'rgb(67 160 71 / 61%)',
                padding: 20,
              }}
            >
              <Grid container spacing={2}>
                <Grid xs={6}>
                  <Typography
                    style={{
                      fontSize: 12,
                      fontWeight: 600,
                      textAlign: 'center',
                      padding: 12,
                    }}
                  >
                    <GiTakeMyMoney
                      style={{
                        fontSize: 50,
                        color: 'white',
                      }}
                    />
                  </Typography>
                </Grid>
                <Grid
                  xs={6}
                  style={{
                    textAlign: 'right',
                    padding: 12,
                    color: 'white',
                  }}
                >
                  Resultado
                  <br />
                  <Typography
                    style={{
                      fontWeight: 600,
                      textAlign: 'right',
                      fontSize: '1.5em',
                    }}
                  >
                    {resultado.toLocaleString('pt-BR', {
                      style: 'currency',
                      currency: 'BRL',
                    })}
                  </Typography>
                </Grid>
              </Grid>
            </Item>
          </Grid>
        </Grid>
        <Table
          dados={lista}
          head={[
            'Data',
            'Descrição',
            'Usuário',
            'Forma Pagamento',
            'Tipo',
            'Valor',
            '',
          ]}
          line={(item) => [
            item[0] ? dayjs(item[0]).format('DD/MM/YYYY') : null,
            item[1],
            item[2][1],
            item[3][1],
            item[4][1],
            item[5].toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            }),
            <IconButton
              key={item[6]}
              title="Excluir"
              size="small"
              onClick={(e) => excluiLancamentoCaixa(e, item[6])}
            >
              <MdDelete />
            </IconButton>,
          ]}
          onClick={handleClickInLine}
        />
      </Grid>
    </Grid>
  )
}

export default memo(Visualiza, isEqual)
